import React from 'react';
import { Grid, TextField, FormControl, Typography, Button, Select, MenuItem, InputLabel } from '@mui/material';

const Generalnfo = (props) => {
  const UserList = props.UserList;

  // const handleNext = () => {
  //   props.handleStep({
  //     service_type: props.postData.service_type&&props.postData.service_type,
  //     distributor_services_type: props.postData.distributor_services_type&&props.postData.distributor_services_type,
  //     distributor_class: props.postData.ds_class&&props.postData.ds_class,
  //     first_name: props.postData.first_name&&props.postData.first_name,
  //     last_name: props.postData.last_name&&props.postData.last_name,
  //     email_address: props.postData.email_address&&props.postData.email_address,
  //     mobile_number: props.postData.mobile_number&&props.postData.mobile_number,
  //     dob: props.postData.dob&&props.postData.dob,
  //     category: props.postData.category&&props.postData.category,
  //     father_name: props.postData.father_name&&props.postData.father_name,
  //     gender: props.postData.gender&&props.postData.gender,
  //     qualification: props.postData.qualification&&props.postData.qualification

  //   }),
  //     props.handleNext();
  // };

  const handleBanknameInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z]/g, '');
  };
  const handleInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z\s]/g, '');
  };
  const handleNumberInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^0-9]/g, '');
  };
  const handleNext = () => {
    // Get only the keys that have a defined value in postData
    const updatedData = Object.keys(props.postData).reduce((acc, key) => {
      if (props.postData[key] !== undefined && props.postData[key] !== null) {
        acc[key] = props.postData[key]; // Only store non-null and non-undefined values
      }
      return acc;
    }, {});

    props.handleStep(updatedData);
    props.handleNext();
  };
  return (
    <>
      <Typography variant="h4" sx={{ mb: 2 }}>
        General Details
      </Typography>
      <Grid container spacing={2} fullwidth>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Type of Service</InputLabel>

            <Select
              label="Type of service"
              name="service_type"
              variant="standard"
              value={props.postData.service_type || UserList.distributor_services_type}
              onChange={(e) => props.handlePostChange(e)}
              // value={UserList.distributor_services_type}
            >
              <MenuItem value={'select'} disabled>
                Select
              </MenuItem>
              <MenuItem value={UserList.distributor_services_type} sx={{ display: 'none' }}>
                {UserList.distributor_services_type}
              </MenuItem>
              <MenuItem value={'FI'}>FI</MenuItem>
              <MenuItem value={'NON FI'}>NON FI</MenuItem>
              <MenuItem value={'ATBC'}>ATBC</MenuItem>
              <MenuItem value={'AECS'}>AECS</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Type of DS</InputLabel>

            <Select
              label="Type of DS"
              name="distributor_type"
              variant="standard"
              value={props.postData.distributor_type || UserList.distributor_type}
              onChange={(e) => props.handlePostChange(e)}
            >
              <MenuItem value={'select'} disabled>
                Select
              </MenuItem>
              <MenuItem value={UserList.distributor_type} sx={{ display: 'none' }}>
                {UserList.distributor_type}
              </MenuItem>
              <MenuItem value={'Hunting'}>Hunting</MenuItem>
              <MenuItem value={'Farming'}>Farming</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Class of DS</InputLabel>

            <Select
              label="Class of DS "
              variant="standard"
              name="ds_class"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.ds_class || UserList.distributor_class}
            >
              <MenuItem value={'select'} disabled>
                Select
              </MenuItem>
              <MenuItem value={UserList.distributor_clas} sx={{ display: 'none' }}>
                {UserList.distributor_clas}
              </MenuItem>
              <MenuItem value={'individual'}>Individual</MenuItem>
              <MenuItem value={'solo'}>Sole proprietors</MenuItem>
              <MenuItem value={'Company'}>Company</MenuItem>
              <MenuItem value={'Partnership Firm'}>Partnership Firm</MenuItem>
              <MenuItem value={'Trust and Society'}>Trust and Society</MenuItem>
              <MenuItem value={'Others'}>Others</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <TextField
              label="First Name"
              name="first_name"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.first_name ?? UserList.first_name ?? ''}
              onInput={handleBanknameInput}
            />
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <TextField
              label="Last Name"
              onChange={(e) => props.handlePostChange(e)}
              name="last_name"
              variant="standard"
              value={props.postData.last_name ?? UserList.last_name ?? ''}
              onInput={handleBanknameInput}
            />
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <TextField
              label="Email Address"
              name="email_address"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.email_address ?? UserList.email_address ?? ''}
            />
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <TextField
              label="Mobile Number"
              name="mobile_number"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.mobile_number ?? UserList.mobile_number ?? ''}
              onInput={handleNumberInput}
            />
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <TextField
              label="DOB"
              variant="standard"
              name="dob"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.dob ?? UserList.dob ?? ''}
            />
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <InputLabel htmlFor="outlined-adornment-lname-register">Category&#42;</InputLabel>

            <Select
              label="Category"
              name="category"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.category || UserList.category}
            >
              <MenuItem value="" disabled>
                select
              </MenuItem>
              <MenuItem value={UserList.category} sx={{ display: 'none' }}>
                {UserList.category}
              </MenuItem>
              <MenuItem value="OBC">OBC</MenuItem>
              <MenuItem value="general">general</MenuItem>
              <MenuItem value="SC-ST">SC-ST</MenuItem>
              <MenuItem value="Others">Others</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <TextField
              label="Father Name"
              variant="standard"
              name="father_name"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.father_name ?? UserList.father_name ?? ''}
              onInput={handleInput}
            />
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <InputLabel htmlFor="outlined-adornment-lname-register">Gender</InputLabel>
            <Select
              label="Gender"
              variant="standard"
              name="gender"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.gender || UserList.gender}
            >
              <MenuItem value="" disabled>
                select
              </MenuItem>
              <MenuItem value={UserList.gender} sx={{ display: 'none' }}>
                {UserList.gender}
              </MenuItem>
              <MenuItem value="Male">Male</MenuItem>
              <MenuItem value="Female">Female</MenuItem>
              <MenuItem value="Others">Others</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <InputLabel htmlFor="outlined-adornment-lname-register">Qualification</InputLabel>
            <Select
              label="Qualification"
              name="qualification"
              variant="standard"
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.qualification || UserList.qualification}
            >
              <MenuItem value="" disabled>
                <em>select</em>
              </MenuItem>
              <MenuItem value={UserList.qualification} sx={{ display: 'none' }}>
                {UserList.qualification}
              </MenuItem>
              <MenuItem value="10th/SSC">10th/SSC</MenuItem>
              <MenuItem value="12th">12th</MenuItem>
              <MenuItem value="Diploma">Diploma</MenuItem>
              <MenuItem value="Graduation">Graduation</MenuItem>
              <MenuItem value="PG">PG</MenuItem>
              <MenuItem value="Doctorate">Doctorate</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {/* <Grid item xl={3} lg={3} md={4} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <TextField
              label="Pincode"
              name='mobile_no'
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.pincode ?? UserList.home_pincode ?? ''}
            />
          </FormControl>
        </Grid> */}
      </Grid>
      <Grid container mt={2} display={'flex'} justifyContent={'center'}>
        <Button
          color="secondary"
          variant="outlined"
          sx={{
            mr: 2,
            width: '25%',
            borderColor: '#688B2A',
            color: '#688B2A',
            borderRadius: '6px',
            '&:hover': {
              borderColor: '#688B2A'
            }
          }}
          onClick={() => props?.setValueEdit(false)}
        >
          back
        </Button>
        <Button
          color="secondary"
          variant="contained"
          sx={{
            width: '25%',
            backgroundColor: '#688B2A',
            color: '#FFFFFF',
            borderRadius: '6px',
            '&:hover': {
              backgroundColor: '#688B2A'
            }
          }}
          onClick={handleNext}
        >
          update
        </Button>
      </Grid>
    </>
  );
};

export default Generalnfo;
